// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__20Rw9","footer":"Form_footer__2MzDE"};